export enum PositionStatus {
  open = "open",
  dust = "dust",
  closed = "closed",
}
